import {
  Component,
  DestroyRef,
  EventEmitter,
  OnInit,
  Output,
  inject,
  input,
  ChangeDetectionStrategy
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AllocationTabSetSelectionService } from '../../services/allocation-tab-set-selection.service';
import { DistributionTabSetSelectionService } from '../../services/distribution-tab-set-selection.service';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'customer-app-tab-selection',
  templateUrl: './tab-selection.component.html',
  styleUrls: ['./tab-selection.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, TranslatePipe]
})
export class TabSelectionComponent implements OnInit {
  private readonly distributionTabSetSelectionService = inject(DistributionTabSetSelectionService);
  private readonly allocationTabSetSelectionService = inject(AllocationTabSetSelectionService);
  private readonly destroyRef = inject(DestroyRef);

  readonly defaultSelection = input<string>(undefined);
  readonly tabNames = input<string[]>(undefined);
  readonly distributionTabSelection = input<boolean>(undefined);
  readonly allocationTabSelection = input<boolean>(undefined);
  readonly showBorder = input<boolean>(undefined);
  readonly disabled = input<boolean>(undefined);
  readonly slimDesign = input<boolean>(undefined);
  @Output() changeSelectionTab = new EventEmitter<string>();

  public selectedTab: string;

  ngOnInit(): void {
    const defaultSelection = this.defaultSelection();
    this.selectedTab = defaultSelection ? defaultSelection : this.tabNames()?.[0];
    this.initSelectionChangeListeners();
  }

  initSelectionChangeListeners(): void {
    if (this.distributionTabSelection()) {
      this.distributionTabSetSelectionService.newValue.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(value => {
        this.changeSelection(value);
      });
    }

    if (this.allocationTabSelection()) {
      this.allocationTabSetSelectionService.newValue.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(value => {
        this.changeSelection(value);
      });
    }
  }

  public changeSelection(tab: string): void {
    this.selectedTab = tab;
    this.changeSelectionTab.emit(this.selectedTab);
  }
}
